import { useMutation } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { MutationComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type SendPushReservationStatusBody = Parameters<typeof apiClient.v2.apiV2ReservationstatusElSendPush>[0]

const sendPushReservationStatus = async (body: SendPushReservationStatusBody) => {
  const { data } = await apiClient.v2.apiV2ReservationstatusElSendPush(body)
  return checkApiResponse(data)
}

export const useV2ReservationStatusSendPushMutation = ({ options }: MutationComposableParams<unknown, SendPushReservationStatusBody> = {}) => {
  return useMutation(() => ({
    mutationFn: sendPushReservationStatus,
    ...resolveMaybeGetter(options ?? {}),
  }))
}
